export default __webpack_public_path__ + "static/media/payment_success.9c412297.svg";